import FormattedMessage from 'I18n/components/FormattedMessage';
import Products from 'merchandise-lib/constants/Product';
import { Link } from 'foundations-components/transitional/components/Link';
import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { getCreateABundleUrl } from 'pricing-pages-lib/utils/urls';
import { useHistory } from 'react-router-dom';
import { NavItemEnum } from '../../constants/routing/NavItems';
import { PRODUCT_PAGE_HEADER } from '../../v2/constants/tracking/TrackingSources';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { useAppSelector } from '../../reducers';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { productsAndPacksForQueryParamsSelector } from '../../selectors/ProductConfigsSelectors';
import { productSelector } from '../../selectors/ProductsSelectors';
import { trackClickedLink } from '../../v2/utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const CalculatorAnchorLink = ({
  productLine,
  nonProductIdentifier
}) => {
  const history = useHistory();
  const isAuthApp = useAppSelector(isAppAuthSelector);
  const isAppReady = useGlobalLoading();

  // get the product so we can create the query params with skuId
  // default to professional if no paid product is found (sales people prefer we default to Pro)
  // default to suite professional bundle if no product line is provided
  const product = useAppSelector(state => {
    if (!isAppReady) return null;
    if (nonProductIdentifier === NavItemEnum.MARKETING_PLUS) {
      return productSelector(state, {
        apiName: Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL
      });
    }
    if (!productLine) {
      return productSelector(state, {
        apiName: Products.CRM_SUITE_PROFESSIONAL_BUNDLE
      });
    }
    return productLine ? productSelector(state, {
      productLine,
      productLevel: 'PROFESSIONAL'
    }) : null;
  });

  // create query params object from product configurations if product exists
  const queryParams = useAppSelector(state => product ? productsAndPacksForQueryParamsSelector(state, {
    productConfigurations: [createProductConfig({
      skuId: product.currentSkuId,
      quantity: 1
    })]
  }) : null);
  const handleClick = () => {
    const url = getCreateABundleUrl(isAuthApp, queryParams);
    trackClickedLink({
      type: 'internal',
      url,
      trackingSource: PRODUCT_PAGE_HEADER,
      value: getI18nText('pricingPage.pages.calculateYourPrice', {
        locale: 'en-us'
      }),
      name: 'calculate-your-price'
    });
    history.push(url);
  };
  return /*#__PURE__*/_jsx(Link, {
    marginInlineStart: "200",
    onClick: handleClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pages.calculateYourPrice"
    })
  });
};
export default CalculatorAnchorLink;